import { render, staticRenderFns } from "./WorkOrderWeekReport.vue?vue&type=template&id=2d4670be"
import script from "./WorkOrderWeekReport.vue?vue&type=script&lang=js"
export * from "./WorkOrderWeekReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports